module.exports = __webpack_public_path__ + "media/img/raport-szkoda-bcg@2x-595888f7.png";